module.exports = __webpack_public_path__ + "static/media/ETH-FTM.ad10bb3a.png";